(() => {
  const initialize = (root) => {
    if (root.dataset.productShareReady === 'true') return;

    const trigger = root.querySelector('[data-product-share-trigger]');
    const panel = root.querySelector('[data-product-share-panel]');
    const copyButton = root.querySelector('[data-product-share-copy]');
    const whatsappLink = root.querySelector('[data-product-share-whatsapp]');
    const emailLink = root.querySelector('[data-product-share-email]');
    const nativeButton = root.querySelector('[data-product-share-native]');
    const status = root.querySelector('[data-product-share-status]');
    const title = root.dataset.productTitle || '';
    const url = root.dataset.productUrl || '';

    if (!trigger || !panel || !copyButton || !whatsappLink || !emailLink || !nativeButton || !status || !url) return;

    root.dataset.productShareReady = 'true';
    const shareText = `${title}\n${url}`;
    whatsappLink.href = `https://wa.me/?text=${encodeURIComponent(shareText)}`;
    emailLink.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(shareText)}`;

    const nativeShareAvailable = typeof navigator.share === 'function';
    nativeButton.hidden = !nativeShareAvailable;

    const isOpen = () => trigger.getAttribute('aria-expanded') === 'true';
    const setStatus = (message) => {
      status.textContent = '';
      window.requestAnimationFrame(() => {
        status.textContent = message;
      });
    };
    const openPanel = () => {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => panel.querySelector('button:not([hidden]), a[href]:not([hidden])')?.focus());
    };
    const closePanel = (restoreFocus = false) => {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) trigger.focus();
    };
    const fallbackCopy = () => {
      const textarea = document.createElement('textarea');
      textarea.value = url;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.inset = '-9999px auto auto -9999px';
      document.body.append(textarea);
      textarea.focus();
      textarea.select();
      const copied = document.execCommand('copy');
      textarea.remove();
      if (!copied) throw new Error('copy failed');
    };

    trigger.addEventListener('click', () => {
      if (isOpen()) closePanel();
      else openPanel();
    });

    copyButton.addEventListener('click', async () => {
      try {
        if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(url);
        else fallbackCopy();
        setStatus(root.dataset.copySuccess || 'Link kopiert');
      } catch {
        setStatus(root.dataset.copyError || 'Link konnte nicht kopiert werden');
      }
    });

    whatsappLink.addEventListener('click', () => closePanel());
    emailLink.addEventListener('click', () => closePanel());

    nativeButton.addEventListener('click', async () => {
      if (!nativeShareAvailable) return;
      try {
        await navigator.share({ title, text: title, url });
        closePanel();
      } catch (error) {
        if (error?.name !== 'AbortError') setStatus(root.dataset.nativeError || 'Teilen nicht möglich');
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen()) {
        event.preventDefault();
        closePanel(true);
      }
    });

    document.addEventListener('pointerdown', (event) => {
      if (isOpen() && !root.contains(event.target)) closePanel();
    });
  };

  const initializeAll = () => document.querySelectorAll('[data-product-share]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
})();
